<template>
  <form class="space-y-6"
        @submit.prevent="submit"
  >

    <div class="-space-y-px rounded-md shadow-sm">
      <div>
        <label for="nameToCallback"
               class="sr-only"
        >{{ placeholderNameText }}
        </label>
        <input v-model="name"
               id="nameToCallback"
               type="text"
               autocomplete="Name"
               required
               class="relative block w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
               :placeholder="placeholderNameText"
        >
      </div>
      <div>
        <label for="phoneNumber"
               class="sr-only"
        >{{ placeholderPhoneText }}
        </label>
        <input v-model="number"
               id="phoneNumber"
               type="text"
               required
               class="relative block w-full appearance-none rounded-none rounded-b-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
               :placeholder="placeholderPhoneText"
        >
      </div>
    </div>

    <div>
      <button type="submit"
              class="button-submit"
              :disabled="mailsent"
              :class="{'bg-green-600 hover:bg-green-600 focus:ring-green-500' : mailsent}"
      >
        {{ buttontext }}
      </button>
    </div>
  </form>
</template>
<script setup>

import {ref} from "vue";

const setLang = defineProps(['lang']);

const lang = setLang['lang']||'en'

const setbuttontext = {
  de: 'Rückruft starten',
  en: "Request callback",
  hu: "Visszahívás kérése"
}

const setSendbuttontextError = {
  de: 'Fehler während Vorgang',
  en: "Error during submission",
  hu: "Hiba a beküldés során"
}

const setSendbuttontextNewRequest = {
  de: 'Neuen Rückruft starten',
  en: "New request",
  hu: "Új kérés"
}

const setSendbuttontext = {
  de: 'moment bitte',
  en: "hold on",
  hu: "pillanatot"
}

const setSendbuttontextConfirmed = {
  de: 'Erfolg',
  en: "Success",
  hu: "Sikerült"
}

const setPlaceholderTextName = {
  de: 'Ihr Name',
  en: "Your name",
  hu: "A neved"
}

const setPlaceholderTextPhone = {
  de: 'Telefonnummer +49123456789',
  en: "Phone +1123456789",
  hu: "Telefonszám +36123456789"
}


const name = ref('')
const number = ref('')
const mailsent = ref(false)
const buttontext = ref(setbuttontext[lang])
const placeholderNameText = ref(setPlaceholderTextName[lang])
const placeholderPhoneText = ref(setPlaceholderTextPhone[lang])



const submit = async () => {
  buttontext.value = setSendbuttontext[lang];
  await fetch(
      'https://api.thermo-control.com/v1/send-callbackp',
      {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        //   credentials: 'include',
        headers: {
          'Accept': 'application/json',
              'Content-Type': 'application/json',
                 "Access-Control-Allow-Headers" : "Content-Type",
          //     "Access-Control-Allow-Origin": "*",
          //       "Access-Control-Allow-Methods": "POST"
        },
        body: JSON.stringify({
          api_key: 'KAyAcRJZUacAYGRCeCfZXRAAAIQgAAEIACBxAggThJDyY0gAAEIQAACEIAABCAAgXoIIE7q',
          name: name.value,
          number: number.value
        })
      }
  ).then(response => response.json())
      .then(data => {
        mailsent.value = data.mailsent;
        buttontext.value = (data.mailsent) ? setSendbuttontextConfirmed[lang] : setSendbuttontextError[lang];
        setTimeout(() => {
          mailsent.value = false;
          name.value = '';
          number.value = '';
          buttontext.value = setSendbuttontextNewRequest[lang];
        }, 3000)
      })

}
</script>